import { AppLayout } from "@/components/layout/AppLayout";

export function DashboardPage() {
  return <AppLayout />;
}
